import { DatePicker, Dropdown, TextField, defaultDatePickerStrings, ChoiceGroup, DropdownMenuItemType, DirectionalHint } from '@fluentui/react'
import { addMonths } from 'date-fns';
import React, { useContext, useEffect, useState,useRef } from 'react';
import { useConst } from '@fluentui/react-hooks';
import { useTranslation } from 'react-i18next';
import userContext from '../../../../context/users/UserContext';
import { USERTYPES } from '../../../../constants/Constants';
import CustomSelect from '../../../../components/CustomSelect';
import CustomeMultiSelect from '../../../../components/CustomMultiSelect';
import themeContext from '../../../../context/theme/ThemeContext';
import studylistContext from '../../../../context/studylist/StudylistContext';
import { choiceGroupStyles } from '../../../Report/helper/initialData';
import { color } from 'd3';
import { getEnv } from '../../../../helpers/EnvHelper';
import { getRadiologistDisplayName } from '../../../../helpers/CommonUtility';

const ExportCsvBody = (props) => {

    const enterprise = (getEnv("REACT_APP_ENTERPRISE_PLATFORM")=="true"||getEnv("REACT_APP_ENTERPRISE_PLATFORM")==true)?true:false;
    const partitionMode= (getEnv("REACT_APP_PARTITION_MODE") == "true" || getEnv("REACT_APP_PARTITION_MODE") == true) ? true : false;
    const isBvp= (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;
    const isVdc = (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_VDC_PLATFORM") == true) ? true : false;
    const isDeeptek = (getEnv("REACT_APP_PLATFORM")=="deeptek")? true:false;
    const {roles} = useContext(userContext);
    const { getThemeColor } = useContext(themeContext);
    const [t] = useTranslation();
    const today = new Date();
    const {clientFirmList, filterInputValues} = useContext(studylistContext);
    const [clientOptions, setClientOptions] = useState([]);
    const [providerOptions, setProviderOptions] = useState([]);
    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);
    const divRef1 = useRef(null);
    const divRef2 = useRef(null);
   
    // const minDate = useConst(addMonths(today, -3));
    const maxDate = today;

    const datePickerStyles = { root: { maxWidth: 300, marginTop: 15 } };

    // const strings = useConst(() => ({
    //     ...defaultDatePickerStrings,
    //     isOutOfBoundsErrorMessage: `Date must be between ${minDate.toLocaleDateString()} and ${maxDate.toLocaleDateString()}`,
    // }));

    const uploadDateFromFunction = (event) => {
        props.setErrorMessage("");
        props.setFilterObj({ ...props.filterObj, uploadDateFrom: event });
        props.setValues({
            ...props.values,
            uploadDateFrom: event
          });
        props.setErrors({
            ...props.errors,
            uploadDateFrom: null
        })
    };

    useEffect(() => {
      if (clientFirmList.length > 0) {
        let tempClientOptions = [];
        clientFirmList.map((item) =>{tempClientOptions.push({key : item.id, text : item.name})})
        setClientOptions(tempClientOptions);
      }

      if (Object.keys(filterInputValues)?.length > 0) {
        let tempProvidersList = [];
        filterInputValues?.radiologistList?.map((item) => {
          const isFirmProvider = item.name != undefined;
          tempProvidersList.push({
            key: isFirmProvider ? "F" + item.id : "R" + item.id,
            text: isFirmProvider
              ? item.name
              : getRadiologistDisplayName(item),
          });
        });
        setProviderOptions(tempProvidersList);
      }
    }, [clientFirmList, filterInputValues]);

    const uploadDateToFunction = (event) => {
        props.setErrorMessage("");
        props.setFilterObj({ ...props.filterObj, uploadDateTo: event });
        props.setValues({
            ...props.values,
            uploadDateTo: event
          });
        props.setErrors({
            ...props.errors,
            uploadDateTo: null
        })
    };
    // export format (csv|excel) is managed by parent via props.selectedExportFormat and props.setSelectedExportFormat
    const tabOptions =[
        { key: 'dptk_allstudiestab', text: 'All Data' },
        { key: 'dptk_reportedstudiestab', text: 'Only Reported Data' },
        { key: 'dptk_unreportedstudiestab', text: 'Only Unreported Data' }
    ];
    const exportFormatOptions = isVdc
    ?[
      { key: 'csv', text: 'CSV' }
    ]
    :
    [
        { key: 'csv', text: 'CSV' },
        // { key: 'excel', text: 'Excel' }
    ];
    const dateOptions =[
        { key: 'upload', text: 'Upload Date (Study Created Date)' },
        { key: 'reported', text: 'Reported Date' }
    ];
    const handleClickOutside = (event) => {
      event.stopPropagation();
      console.log('clicking outside', event);
      console.log('div ref', divRef1);
      if (divRef1.current && dropdownRef1.current && !divRef1.current.contains(event.target)) {
        dropdownRef1.current.dismissMenu();
        console.log('if.................')
      }
      if (divRef2.current && dropdownRef2.current && !divRef2.current.contains(event.target)) {
        dropdownRef2.current.dismissMenu();
        console.log('if.................')
      }
      
    };
  
    const resetDateDependentFields = () => {
      props.setFilterObj(prev => ({
        ...prev,
        uploadDateFrom: null,
        uploadDateTo: null
      }));

      props.setValues(prev => ({
        ...prev,
        uploadDateFrom: null,
        uploadDateTo: null
      }));

      props.setErrors(prev => ({
        ...prev,
        uploadDateFrom: null,
        uploadDateTo: null
      }));

      props.setErrorMessage("");
      props.setSelectedTabOption("dptk_allstudiestab");
      props.setSelectedClientList([]);
      props.setSelectedProviderList([]);
      props.setSelectedFirm(null);
      props.setSelectedFirmObj(null);
    };

  return (
    <div className="close-study-container" onClick={handleClickOutside}>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row" style={{ marginButtom: "10px" }}>
          <fieldset className="border rounded p-4">
            <legend className="font-bold">{t("export-csv.report-format")}</legend>
            <ChoiceGroup
              // defaultSelectedKey= {props.selectedExportFormat || "csv"}
               defaultSelectedKey={
                isVdc ? "csv" : (props.selectedExportFormat || "csv")
                }
              styles={choiceGroupStyles}
              options={exportFormatOptions}
              onChange={(ev, item) => {
                if (props.setSelectedExportFormat) props.setSelectedExportFormat(item.key);
              }}
              label=""
            />
          </fieldset>
        </div>
        
        <div className="ms-Grid-row" style={{ marginButtom: "10px"}}>
          <fieldset className="border rounded p-4">
            <legend className="font-bold">{t("export-csv.date-mode")}</legend>
            <ChoiceGroup
              defaultSelectedKey="upload"
              styles={choiceGroupStyles}
              options={dateOptions}
              onChange={(ev, item) => {
                if (item.key !== props.selectedDateOption) {
                  resetDateDependentFields();
                }
                props.setSelectedDateOption(item.key);
              }}
              label=""
            />
          </fieldset>
        </div>
        

        <div className="ms-Grid-row">
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            value={props.filterObj.uploadDateFrom}
            name="uploadDateFrom"
            style={datePickerStyles}
            onSelectDate={uploadDateFromFunction}
            //strings={strings}
            placeholder="dd-mmm-yyyy"
            // minDate={minDate}
            maxDate={maxDate}
            label={
              <span>
                {props.selectedDateOption === "upload"
                  ? t("export-csv.upload-date-from")
                  : t("export-csv.reported-date-from")}
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              </span>
            }
            // label={t("export-csv.upload-date-from")}
            formatDate={(date) => {
              const day = date.getDate().toString().padStart(2, "0");
              const month = new Intl.DateTimeFormat("en", {
                month: "short",
              }).format(date);
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }}
            // isRequired
            textField={{
              errorMessage: props.errors.uploadDateFrom
                ? props.errors.uploadDateFrom
                : undefined,
            }}
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            value={props.filterObj.uploadDateTo}
            name="uploadDateTo"
            onSelectDate={uploadDateToFunction}
            //strings={strings}
            placeholder="dd-mmm-yyyy"
            // minDate={minDate}
            maxDate={maxDate}
            formatDate={(date) => {
              const day = date.getDate().toString().padStart(2, "0");
              const month = new Intl.DateTimeFormat("en", {
                month: "short",
              }).format(date);
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }}
            label={
              <span>
                {props.selectedDateOption === "upload"
                  ? t("export-csv.upload-date-to")
                  : t("export-csv.reported-date-to")}
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              </span>
            }
            // label={t("export-csv.upload-date-to")}
            // isRequired
            textField={{
              errorMessage: props.errors.uploadDateTo
                ? props.errors.uploadDateTo
                : undefined,
            }}
          />
        </div>
        {(enterprise
          ? roles[0] === USERTYPES.FIRMADMIN
          : roles[0] === USERTYPES.ADMIN) && (
          <>
            <div className="ms-Grid-row" style={{ marginTop: "5px" }}>
              <div
                style={{ color: getThemeColor("primary-color") }}
                className="upload-study-body-label"
              >
              </div>
              <CustomeMultiSelect
                options={props.finalFirmList.map(firm => ({
                  key: firm.value ?? firm.id ?? firm.key,
                  text: firm.text ?? firm.label ?? firm.name
                }))}
                placeholder="Select Firm"
                selectedKeys={props.selectedFirm ? [props.selectedFirm] : []}
                setSelectedKeys={(keys) => {
                  const firmKey = keys[0] || null;
                  props.setSelectedFirm(firmKey);
                  const firmObj = props.finalFirmList.find(f =>
                    (f.value ?? f.id ?? f.key) === firmKey
                  );
                  props.setSelectedFirmObj(firmObj || null);
                }}
                label={t("user.firm")}
                multiSelect={false}
                showCheckbox={false}
                calloutProps={{
                  bounds: props.calloutBounds,
                  directionalHint: DirectionalHint.bottomAutoEdge,
                }}
                customClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
              />
            </div>
          </>
        )}
        {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) && (
          <div className="ms-Grid-row" ref={divRef1} style={{ marginButtom: "10px" }}>
            <CustomeMultiSelect
            customClassName={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"}
            dropdownRef = {dropdownRef1}
            options ={clientOptions}
            placeholder ="Select Clients"
            selectedKeys ={props.selectedClientList}
            setSelectedKeys={props.setSelectedClientList}
            label={"Clients"}
            showSelectAll={isVdc === true}
            calloutProps={{
              bounds: props.calloutBounds,
              directionalHint: DirectionalHint.bottomAutoEdge,
            }}

            />
          </div>
        )}
        {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) && (
          <div className="ms-Grid-row" ref={divRef2} style={{ marginButtom: "10px" }}>
            <CustomeMultiSelect
            customClassName={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"}
            dropdownRef = {dropdownRef2}
            options ={providerOptions}
            placeholder ="Select Providers"
            selectedKeys ={props.selectedProviderList}
            setSelectedKeys={props.setSelectedProviderList}
            label={"Providers"}
            calloutProps={{
              bounds: props.calloutBounds,
              directionalHint: DirectionalHint.bottomAutoEdge,
            }}
            />
          </div>
        )}
        {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR || roles[0] === USERTYPES.FIRMDOCTOR ||  roles[0] === USERTYPES.FIRMTECHNICIAN ) && props.selectedDateOption === "upload" && (
          <div
            className="ms-Grid-row"
            style={{ marginButtom: "10px", marginLeft: "4px" }}
          >
            <ChoiceGroup
              defaultSelectedKey="dptk_allstudiestab"
              styles={choiceGroupStyles}
              options={tabOptions}
              onChange={(ev, item) => {
                props.setSelectedTabOption(item.key);
              }}
              label=""
            />
          </div>
        )}
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
        <div style={{ marginTop: "15px", fontSize: "13px" }}>
          <strong>Note:</strong>{" "} {partitionMode && !isBvp && !isDeeptek && "Data is available for the past 3 months. "} A maximum of 45 days of data can be exported per request.
        </div>
        <div className="form-mt-10 custom-required-error-msg">
          {props.errorMessage}
        </div>
      </div>
    </div>
  );
}

export default ExportCsvBody